import type React from 'react'

import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { TextBoxCaption4WarningCenter } from 'atoms/TextBox/Templates'
import { ErrorMessageWrapper, InputBlockCardSC } from './PopupComponents.styled'

export interface IInputBlockCard {
  children?: React.ReactNode
  title: string
  errorMessage?: string
}

export const InputBlockCard = ({
  children,
  title,
  errorMessage,
}: IInputBlockCard) => {
  return (
    <InputBlockCardSC>
      <TextBox
        maxLines={1}
        font={TextBoxTypes.Footnote5}
        color={TextBoxColors.TEXT_ICON_PRIMARY}
        title={title}
      />
      {children}
      <ErrorMessageWrapper>
        {errorMessage && <TextBoxCaption4WarningCenter title={errorMessage} />}
      </ErrorMessageWrapper>
    </InputBlockCardSC>
  )
}
